module.exports = __webpack_public_path__ + "img/lubricants.fb4d1637.jpg";